<template>
  <section class="reply-refer-form">
    <el-form
      ref="form"
      :model="item"
      :rules="formRules">
      <div v-show="item.quote_status == 0 && editType == 3">
        <div class="flex-sb">
          <div class="form-item form-half">
            <span>Insurer Quote Status</span>
            <el-form-item
              ref="quote_status"
              prop="quote_status">
              <v-radio-group
                v-model="item.quote_status"
                :border="true"
                :list="quoteStatusOptions" />
            </el-form-item>
          </div>
        </div>
        <div class="box">
          <div class="form-item form-half">
            <span>Insurer</span>
            <el-form-item
              ref="company_id"
              prop="company_id">
              <v-select
                v-model="item.company_id"
                :list="localAllOptions.insurer"
                :disabled="editType == 3 && index == 0"
                @change="()=>(formDataLock+=1)" />
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>Class of Insurance</span>
            <el-form-item>
              <v-select
                v-model="item.plan_id"
                :list="currentPlanOptions"
                :disabled="showBuyable || (editType == 3 && index == 0)"
                @change="changePlan" />
            </el-form-item>
          </div>
          <div
            v-if="item.quote_status==0"
            class="form-item form-half">
            <span>Reject Renewal Notice</span>
            <el-form-item
              ref="renew_file_path_id"
              prop="renew_file_path_id">
              <v-upload
                card
                widthFull
                :fileData="reject_fileData[index]"
                :otherData="otherData"
                @delete="handleDel"
                @uploadSuccess="handlerUploadSuccess" />
            </el-form-item>
          </div>
        </div>
      </div>
      <div v-show="(item.quote_status != 0 && editType == 3) || editType != 3">
        <div class="flex-sb">
          <div class="form-item form-half">
            <span>Insurer Quote Status</span>
            <el-form-item
              ref="quote_status"
              prop="quote_status">
              <v-radio-group
                v-model="item.quote_status"
                :border="true"
                :list="quoteStatusOptions"
                :disabled="showBuyable || editType == 2"/>
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>Total Payable</span>
            <span>{{ item.payable }}</span>
          </div>
        </div>
        <div class="box">
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Insurer</span>
              <el-form-item
                ref="company_id"
                prop="company_id">
                <v-select
                  v-model="item.company_id"
                  :list="localAllOptions.insurer"
                  :disabled="showBuyable || (editType == 3 && index == 0)"
                  @change="changeCompany"/>
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>Type of Insurance</span>
              <v-select
                v-model="item.class_id"
                :disabled="true"
                :list="classOptions"
              />
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Class of Insurance</span>
              <el-form-item
                ref="plan_id"
                prop="plan_id">
                <v-select
                  v-model="item.plan_id"
                  :list="currentPlanOptions"
                  :disabled="showBuyable || (editType == 3 && index == 0)"
                  @change="changePlan"/>
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>Policyholder</span>
              <v-input
                v-model="item.isrd_nm"
                :disabled="true"
              />
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Quotation Number</span>
              <v-input
                v-model="item.quote_no"
                :disabled="true"
              />
            </div>
            <div class="form-item form-half">
              <span>Type of quotation</span>
              <v-select
                v-model="item.type"
                :disabled="true"
                :list="globalOptions.quote_type"
              />
            </div>
          </div>
          <div
            class="flex-sb">
            <div class="form-item form-half">
              <span>Expected Effective Date </span>
              <el-form-item
                ref="pcy_cmnt_dt"
                prop="pcy_cmnt_dt">
                <v-date-picker
                  v-model="item.pcy_cmnt_dt"
                  :disabled="showBuyable || Boolean(item.pcy_cmnt_dt)"/>
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>Expected Expiry Date</span>
              <el-form-item
                ref="pcy_expry_dt"
                prop="pcy_expry_dt">
                <v-date-picker
                  v-model="item.pcy_expry_dt"
                  :disabled="showBuyable || item.pcy_expry_dt != ''"/>
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="box">
          <h3>Coverage</h3>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Personal Accident：Accident while in a Common Carrier</span>
              <v-input
                v-model="item.personal_accident_carrier"
                :keyFloatNumber="true"
                maxlength="9"
                :disabled="showBuyable" />
            </div>
            <div class="form-item form-half">
              <span>Baggage & Personal Effects</span>
              <v-input
                v-model="item.baggage_personal_effects"
                :keyFloatNumber="true"
                maxlength="9"
                :disabled="showBuyable" />
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Personal Accident：Other Accidents</span>
              <v-input
                v-model="item.personal_accident_other"
                :keyFloatNumber="true"
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
            <div class="form-item form-half">
              <span>Travel Document</span>
              <v-input
                v-model="item.travel_document"
                :keyFloatNumber="true"
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Emergency Medical Evacuation and Repatriation of Remains</span>
              <v-input
                v-model="item.emergency_medical_evacuation"
                :keyFloatNumber="true"
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
            <div class="form-item form-half">
              <span>Personal Liability</span>
              <v-input
                v-model="item.personal_liability"
                :keyFloatNumber="true"
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Overseas Hospital Income</span>
              <v-input
                v-model="item.overseas_hospital_income"
                :keyFloatNumber="true"
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
            <div class="form-item form-half">
              <span>Travel Delay</span>
              <v-input
                v-model="item.travel_delay"
                :keyFloatNumber="true"
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Compassionate Visit</span>
              <v-input
                v-model="item.compassionate_visit"
                :keyFloatNumber="true"
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
            <div class="form-item form-half">
              <span>Baggage Delay</span>
              <v-input
                v-model="item.baggage_delay"
                :keyFloatNumber="true"
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
          </div>

          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Compassionate Death Cash</span>
              <v-input
                v-model="item.compassionate_death_cash"
                :keyFloatNumber="true"
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
            <div class="form-item form-half">
              <span>Kidnapping Benefit</span>
              <v-input
                v-model="item.kidnapping_benefit"
                :keyFloatNumber="true"
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Journey Curtailment</span>
              <v-input
                v-model="item.journey_curtailment"
                :keyFloatNumber="true"
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
            <div class="form-item form-half">
              <span>Medical Expenses</span>
              <v-input
                v-model="item.medical_expenses"
                :keyFloatNumber="true"
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
          </div>
          <div
            v-if="plan_cvr_remark"
            class="form-item">
            <span>Plan Coverage Remark</span>
            <span>{{plan_cvr_remark}}</span>
          </div>
          <div class="flex-sb">
            <div class="form-half">
              <div class="form-item">
                <span>Coverage Remark</span>
                <v-input
                  v-model="item.cvr_remark"
                  type="textarea"
                  :rows="3"
                />
              </div>
            </div>
          </div>
        </div>
        <benefit-form
          ref="benefit-form"
          :form="item"
          :formDataLock="excessFormDataLock"
          :editType="editType"
          :renewOrderId="renewOrderId"
          :classId="item.class_id"
          :disabled="showBuyable"
          @getSubmitPremium="getSubmitPremium"
          @getFormData="submitPremium" />
        <!--      <div class="box">-->
        <!--        <span class="title">More Benefits</span>-->
        <!--        <div class="form-item">-->
        <!--          <v-checkbox-group-->
        <!--            v-model="item.benefits"-->
        <!--            :block="true"-->
        <!--            :list="localAllOptions.benefits">-->
        <!--            <template v-slot:input="input">-->
        <!--              <v-input v-model="item.benefit_coverage[input.id]" />-->
        <!--            </template>-->
        <!--          </v-checkbox-group>-->
        <!--        </div>-->

        <!--      </div>-->

        <div class="box">
          <refer-underwriting
            ref="refer-underwriting"
            :form="item"
            :classId="item.class_id"
            :disabled="showBuyable"
            :editType="editType"
            :renewOrderId="renewOrderId"
            :formDataLock="excessFormDataLock"
            @sendPlanCvrRemark="getPlanCvrRemark"
            @getSubmitPremium="getSubmitPremium"
            @getFormData="submitPremium" />
        <!--        <h3>Underwriting Question</h3>-->
        <!--        <div class="flex-sb-wrap">-->
        <!--          <div-->
        <!--            v-for="(inItem, inIndex) in item.underwriting"-->
        <!--            :key="inIndex"-->
        <!--            class="form-item form-half">-->
        <!--            <span>{{ inItem.name }}</span>-->
        <!--            <v-radio-group-->
        <!--              v-model="inItem.answer"-->
        <!--              :disabled="showBuyable"-->
        <!--              :border="true"-->
        <!--              :list="yesNoOptions" />-->
        <!--          </div>-->
        <!--        </div>-->
        </div>
        <div class="box">
          <h3>Remarks</h3>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Policy Remark</span>
              <v-input
                v-model="item.cs_manual_remark"
                type="textarea"
                :disabled="showBuyable"
                :rows="6" />
            </div>
          </div>
        </div>
        <premium-form
          ref="premium"
          :classId="item.class_id"
          :customerId="customerId"
          :disabled="showBuyable"
          :editType="editType"
          :renewOrderId="renewOrderId"
          :form="item"
          :benefitList="benefitList"
          :formDataLock="excessFormDataLock"
          @submitPremium="submitPremium"
          @getSubmitPremium="getSubmitPremium"></premium-form>
      </div>
    </el-form>
  </section>
</template>
<script>
import MixinRules from '@/mixins/rules'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import PremiumForm from '@/views/components/premium-form'
import benefitForm from '@/views/tickets/components/modules/component/more-benefit'
import referUnderwriting from '@/views/tickets/components/form/refer-underwriting'

export default {
  name: 'WorkingReplyReferForm',
  components: {
    PremiumForm,
    benefitForm,
    referUnderwriting
  },
  mixins: [MixinOptions, MixinRules, MixinFormat],
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    index: [String, Number],
    customerId: {
      type: [Number,String],
      default: '' // 1 - reply, 2 - upgrade
    },
    showBuyable:{
      type:Boolean,
      default:false
    },
    editType: {
      type: Number,
      default: 1 // 1 - reply, 2 - upgrade, 3 - renew
    },
    renewOrderId:{
      type: [Number, String],
      default: null
    },
    reject_fileData:{
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      excessFormDataLock: 0,
      parentOtherData: null,
      quoteStatusOptions: [
        {
          name: 'Quoted',
          id: 1
        },
        {
          name: 'Rejected',
          id: 0
        },
      ],
      subForm: {
        'premium':false,
        'benefit-form':false,
      },
      plan_cvr_remark: '',
      benefitList: [],
      otherData:{
        target: 'renew_file_path_id',
        index: this.index,
        name: 'working-reply-refer-form'
      }
    }
  },
  computed: {
    formRules() {
      const {quote_status} = this.item
      var rule = JSON.stringify(this.rules)
      const data =[
        'basic_prm',
        'code_disc_pct',
        'ia_levy_pct',
        'spec_disc_pct',
        'handling_fee',
        'age_limits'
      ]
      rule = JSON.parse(rule)
      data.forEach(item=>{
        rule[item][0].required =false
      })
      return quote_status==0? rule:this.rules
    },
    localAllOptions() {
      return this.allOptions22
    },
    currentPlanOptions() {
      if(!this.globalOptions || !this.globalOptions.plan) {
        return []
      }
      const { class_id, company_id } = this.item
      const key = `${company_id}${class_id}`
      return this.globalOptions.plan.filter(item => item.category_id == key)
    }
  },
  watch:{
    'item.plan_id': {
      immediate: true,
      deep: true,
      handler(val) {
        if(val) {
          this.changePlan()
        }
      }
    },
    'item.quote_status':{
      immediate: true,
      deep: true,
      handler(val){
        if(val == 1){
          this.handleDel({otherData: this.otherData})
        }
      }
    }
  },
  methods: {
    handleDel(otherData){
      this.$emit('delete', otherData)
    },
    handlerUploadSuccess(uploadRsult){
      this.$emit('uploadSuccess',uploadRsult)
    },
    async validateForm(otherData) {
      Object.keys(this.subForm).some(key => {
        this.subForm[key] = false
        this.$refs[key].submitForm(key)
      })
      if (Object.values(this.subForm).some(item => item === false)) {
        return
      }
      // this.$refs.premium.submitForm()
      await new Promise((resolve, reject) => {
        this.$refs['form'].validate((valid, rules) => {
          if(valid) {
            this.parentOtherData = otherData
            // 處理 excess 數據
            // this.$refs['housemaid-excess-form'].submitForm()
            this.$emit('validate', otherData)
            resolve(valid)
          }
          else {
            this.scrollToValidDom(rules)
            reject(valid)
          }
        })
      })
    },
    getSubFormData(data) {
      Object.assign(this.item, data)
      this.$emit('validate', this.parentOtherData)
    },
    getSubmitPremium(data, index, name){
      if(name == 'benefit'){
        this.benefitList = []
        Object.assign(this.benefitList, data.benefits)
      }
      Object.assign(this.item, data)
      this.$forceUpdate()
    },
    getPlanCvrRemark(data){
      this.plan_cvr_remark = data
    },
    submitPremium(form,data){
      this.subForm[form] = true
      Object.assign(this.item, data)
    },
    handlerReferralMain() {
      this.$emit('getPremium', this.index)
    },
    changeCompany(index) {
      this.excessFormDataLock += 1
      this.$set(this.item, 'plan_id', '')
    },
    changePlan() {
      this.excessFormDataLock += 1
      this.$emit('changePlan', this.currentPlanOptions)
    },
    planOptions() {
      const { class_id, company_id } = this.item
      if(!class_id || !company_id) return []

      const key = `${company_id}${class_id}`
      const { plan } = this.globalOptions
      const options = plan[key]
      if(!options) return []
      return options
    },
  }
}
</script>
